<template>
    <div>
        <h1 class="pagetitle">Visual Type™ Explorer</h1>

        <visual-type-graph
            class="visualtype-height flex flex-col justify-end"
            :visual_types="visual_types"
        />

        <div class="flex flex-row flex-wrap lg:flex-no-wrap justify-center">
            <div v-for="visual_type in visual_types"
                class="w-1/4 flex flex-row pr-3"
                :style="{ backgroundColor: visual_type.bg_color }"
            >
                <div class="w-0 lg:w-8"
                    :style="{ color: visual_type.color }"
                ></div>

                <div class="flex flex-col pl-2">
                    <div class="text-xxs lg:text-xs pt-1 font-bold">{{ visual_type.title }}</div>
                    <input class="field accordion-height w-full pb-1 mb-2 bg-transparent border-0 border-b-2 border-gray-900 font-mono"
                        :name="visual_type.id"
                        type="number"
                        min="1"
                        max="100"
                        step="1"
                        v-model.number="visual_type.value"
                        @change="valueChanged(visual_type)"
                        @input="needs_saving = true"
                    />
                </div>
            </div>
        </div>

        <div class="flex justify-center my-4">
            <button
                class="px-6 py-3 text-lg inline-block m-auto transition"
                :class="needs_saving ? 'cursor-pointer bg-green-400 text-2xl' : 'opacity-50 hover:bg-indigo-500 hover:text-white cursor-not-allowed'"
                @click="updateValues"
            >
                Save Changes
            </button>
        </div>

        <!-- The accordions from Blade will be added to this slot -->
        <!-- and will have access to "values" as "scope.values" from this parent component -->
        <slot :values="values" />
    </div>
</template>

<script>
import axios from 'axios';
import VisualTypeGraph from './visual-type-graph.vue';

export default {
    components: {
        VisualTypeGraph,
    },

    props: {
        user_id: {},
        initial_visual_types: {},
    },

    data() {
        return {
            needs_saving: false,
            visual_types: this.initial_visual_types,
        }
    },

    computed: {
        values() {
            let values = {};
            this.visual_types.map((visual_type) => {
                values[visual_type.id] = visual_type.value;
            });

            return values;
        },
    },

    methods: {
        updateValues() {
            if (! this.needs_saving) {
                return;
            }

            axios.put('/users/' + this.user_id + '/visualtype', { visual_types: this.visual_types })
                .then(response => {
                    this.visual_types = response.data;
                    this.needs_saving = false;
                }).catch(error => {
                    console.log(error.response);
                    this.needs_saving = false;
                })
        },
        validateMaxValue() {
            Object.keys(this.visual_types).forEach(key => {
                let entered_value = this.visual_types[key].value;

                this.visual_types[key].value = entered_value !== ''
                    ? Math.min(Math.max(parseInt(entered_value), 0), 100)
                    : '';
            })
        },
        valueChanged(visual_type) {
            if (! visual_type.value) {
                visual_type.value = 1;
            }
        },
    },

    watch: {
        visual_types: {
            deep: true,
            handler(val) {
                this.validateMaxValue();
            },
        }
    },
}
</script>

<style lang="scss">
    .visualtype-height {
        height: 40vh;
        max-height: 60vw;
    }
    .accordion-height {
        height: 34px;
        @apply text-sm;
    }

    @screen md {
        .visualtype-height {
            height: 40vh;
            max-height: 50vw;
        }
        .accordion-height {
            @apply text-xl;
        }
    }
    @screen lg {
        .visualtype-height {
            height: 70vh;
            max-height: 40vw;
        }
        .accordion-height {
            @apply text-xl;
        }
    }
</style>
